"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroPrincipal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="hero-principal" className="relative min-h-screen w-full overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center md:bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1534050/img/image_0a6facvh.png)]" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-b from-dark-background/60 via-dark-background/70 to-dark-background/60" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 flex min-h-screen items-center justify-center px-6 py-16 transition-all duration-[200ms] ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-8 lg:grid-cols-[1fr_auto]">
          {}
          <div className="space-y-6 text-left">
            <h1 className="font-display text-4xl font-bold leading-tight text-foreground-dark md:text-5xl lg:text-6xl">Poire Com : Agence de Communication 360&nbsp;</h1>
            <p className="max-w-2xl font-body text-lg leading-relaxed text-foreground-dark/90 md:text-xl">Référencement IA | Publicité Google Ads | Réseaux sociaux sponsorisés |&nbsp; Campagnes SMS sur nouveaux prospects | Création de site internet Wordpress | Goodies | Distribution de flyers | Planificateur de réseaux sociaux | Création de vidéos<br /><br /></p>
          </div>

          {}
          <div className="flex justify-start lg:justify-end">
            <Link to="#nos-services">
              <Button size="lg" className="btn-primary text-base font-semibold shadow-strong transition-transform duration-[80ms] ease-[var(--ease-spring)] hover:scale-[1.02]">Découvrir nos services</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}